// import React from "react";
import { Routes, Route } from "react-router-dom";
import Layout from "../components/layout/Layout";
import LoginNew from "../features/login/Login";
import User from "../features/user/User";
import CreateUser from "../features/user/CreateUser";
import UserType from "../features/userType/UserType";
import CreateUserType from "../features/userType/CreateUserType";
import Rights from "../features/rights/Rights";
import Menu from "../features/menu/Menu";
import PrivateRoute from "./PrivateRoute";
import Dashboard from "../features/dashboard/Dashboard";
// import LoginNew from "../features/login/LoginNew";
import PendingDocumentTourBooking from "../features/dashboard/lists/PendingDocumentTourBooking";
import TotalTourBooking from "../features/dashboard/lists/TotalTourBooking";
// import TotalPayment from "../features/dashboard/lists/TotalPayment";
import TotalPendingPayment from "../features/dashboard/lists/TotalPendingPayment";
import TotalDepartureInNextFifteenDay from "../features/dashboard/lists/TotalDepartureInNextFifteenDay";

import Banner from "../features/banner/Banner";
import CreateBanner from "../features/banner/CreateBanner";
import CMS from "../features/cms/CMS";
import SeoTag from "../features/seotag/SeoTag";
import CreateSeoTag from "../features/seotag/CreateSeoTag";
import Testimonial from "../features/testimonial/Testimonial";
import CreateCMS from "../features/cms/CreateCMS";
import Blog from "../features/blog/Blog";
import CreateBlog from "../features/blog/CreateBlog";
import FAQ from "../features/faq/FAQ";
import CreateFAQ from "../features/faq/CreateFAQ";
// import UsefulLinks from "../features/usefullinks/UsefulLinks";
// import CreateUsefulLinks from "../features/usefullinks/CreateUsefulLinks";
import Setting from "../features/setting/Setting";
import Workflow from "../features/workflow/Workflow";
import CreateWorkflow from "../features/workflow/CreateWorkflow";
import ClientLogo from "../features/clientlogo/ClientLogo";
import About from "../features/about/About";
import CoreServices from "../features/coreservices/CoreServices";
import Services from "../features/services/Services";
import CreateCoreServices from "../features/coreservices/CreateCoreServices";
import CreateServices from "../features/services/CreateServices";
import WeProvide from "../features/weprovide/WeProvide";
import CreateWeProvide from "../features/weprovide/CreateWeProvide";
import WhyChoose from "../features/whychoose/WhyChoose";
import CreateWhyChoose from "../features/whychoose/CreateWhyChoose";
import Branch from "../features/branches/Branch";
import CreateBranch from "../features/branches/CreateBranch";
import Technologies from "../features/technologies/Technology";
import CreateTechnologies from "../features/technologies/CreateTechnology";
import WorkCulture from "../features/workculture/WorkCulture";
import CreateWorkCulture from "../features/workculture/CreateWorkCulture";
import BestPlace from "../features/bestplace/BestPlace";
import WorkPlace from "../features/workplace/WorkPlace";
import PortfolioItems from "../features/portfolioitem/PortfolioItem";
import CreatePortfolioItems from "../features/portfolioitem/CreatePortfolioItem";
import Opening from "../features/openings/Openings";
import CreateOpening from "../features/openings/CreateOpenings";
import Gallary from "../features/gallary/Gallary";
import TeamMember from "../features/teammember/TeamMember";
import Contacts from "../features/inquiries/Contacts";
import CaseStudies from "../features/casestudies/CaseStudies";
import CreateCaseStudies from "../features/casestudies/CreateCaseStudies";

const MainRouter = () => {
  return (
    <Routes>
      {/* <Route path="login" element={<LogIn />} /> */}
      {/* <Route path="newlogin" element={<NewLogin />} /> */}
      <Route path="login" element={<LoginNew />} />

      <Route
        path="/"
        element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }
      >
        <Route index={true} element={<Dashboard />} />
        <Route element={<Banner />} />
        <Route path="menu" element={<Menu />} />
        <Route path="rights" element={<Rights />} />
        <Route path="user" element={<User />} />
        <Route path="user/create" element={<CreateUser />} />
        <Route path="user/edit" element={<CreateUser />} />
        <Route path="usertype" element={<UserType />} />
        <Route path="usertype/create" element={<CreateUserType />} />
        <Route path="usertype/edit" element={<CreateUserType />} />
        <Route path="cms" element={<CMS />} />
        <Route path="cms/edit" element={<CreateCMS />} />
        <Route path="cms/create" element={<CreateCMS />} />
        <Route path="banner" element={<Banner />} />
        <Route path="banner/create" element={<CreateBanner />} />
        <Route path="banner/edit" element={<CreateBanner />} />
        <Route path="seotag" element={<SeoTag />} />
        <Route path="seotag/create" element={<CreateSeoTag />} />
        <Route path="seotag/edit" element={<CreateSeoTag />} />
        <Route path="testimonial" element={<Testimonial />} />
        <Route path="blog" element={<Blog />} />
        <Route path="blog/create" element={<CreateBlog />} />
        <Route path="blog/edit" element={<CreateBlog />} />
        <Route path="clients" element={<ClientLogo />} />
        <Route path="gallery" element={<Gallary />} />
        <Route path="teammember" element={<TeamMember />} />
        <Route path="contacts" element={<Contacts />} />

        <Route path="coreservices" element={<CoreServices />} />
        <Route path="coreservices/create" element={<CreateCoreServices />} />
        <Route path="coreservices/edit" element={<CreateCoreServices />} />

        <Route path="casestudies" element={<CaseStudies />} />
        <Route path="casestudies/create" element={<CreateCaseStudies />} />
        <Route path="casestudies/edit" element={<CreateCaseStudies />} />
        
        <Route path="services" element={<Services />} />
        <Route path="services/create" element={<CreateServices />} />
        <Route path="services/edit" element={<CreateServices />} />

        <Route path="branches" element={<Branch />} />
        <Route path="branches/create" element={<CreateBranch />} />
        <Route path="branches/edit" element={<CreateBranch />} />

        <Route path="whychoose" element={<WhyChoose />} />
        <Route path="whychoose/create" element={<CreateWhyChoose />} />
        <Route path="whychoose/edit" element={<CreateWhyChoose />} />

        <Route path="workculture" element={<WorkCulture />} />
        <Route path="workculture/create" element={<CreateWorkCulture />} />

        <Route path="bestplace" element={<BestPlace />} />
        <Route path="workplace" element={<WorkPlace />} />

        <Route path="portfolioitems" element={<PortfolioItems />} />
        <Route path="portfolioitems/create" element={<CreatePortfolioItems />} />
        <Route path="portfolioitems/edit" element={<CreatePortfolioItems />} />

        <Route path="opening" element={<Opening />} />
        <Route path="opening/create" element={<CreateOpening />} />
        <Route path="opening/edit" element={<CreateOpening />} />

        <Route path="weprovide" element={<WeProvide />} />
        <Route path="weprovide/create" element={<CreateWeProvide />} />
        <Route path="weprovide/edit" element={<CreateWeProvide />} />

        <Route path="technologies" element={<Technologies />} />
        <Route path="technologies/create" element={<CreateTechnologies />} />
        <Route path="technologies/edit" element={<CreateTechnologies />} />

        <Route path="faq" element={<FAQ />} />
        <Route path="faq/create" element={<CreateFAQ />} />
        <Route path="faq/edit" element={<CreateFAQ />} />
        
        {/* <Route path="usefullinks" element={<UsefulLinks />} />
        <Route path="usefullinks/create" element={<CreateUsefulLinks />} />
        <Route path="usefullinks/edit" element={<CreateUsefulLinks />} /> */}
        <Route path="inquiries" element={<Contacts />} />
        <Route path="setting" element={<Setting />} />
        <Route
          path="dashboard/pendingdocumenttourbooking"
          element={<PendingDocumentTourBooking />}
        />
        <Route path="dashboard/ticketbookings" element={<TotalTourBooking />} />
        <Route path="dashboard/totalpayments" element={<TotalTourBooking />} />
        {/* <Route path="dashboard/payments" element={<TotalPayment />} /> */}
        <Route
          path="dashboard/pendingpayments"
          element={<TotalPendingPayment />}
        />
        <Route
          path="dashboard/next15daysdeparture"
          element={<TotalDepartureInNextFifteenDay />}
        />
        <Route path="workflow" element={<Workflow />} />
        <Route path="workflow/create" element={<CreateWorkflow />} />
        <Route path="workflow/edit" element={<CreateWorkflow />} />
        <Route path="about" element={<About />} />
        <Route path="*" element={<h1>404</h1>} />
      </Route>
    </Routes>
  );
};

export default MainRouter;
